import Header from './components/Header';
import Hero from './components/Hero';
import Categories from './components/Categories';
import Featured from './components/Featured';
import Collections from './components/Collections';
import Articles from './components/Articles';
import Faq from './components/Faq';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';
import { faqs } from '@/mocks/yokaiManga';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.q,
    acceptedAnswer: { '@type': 'Answer', text: faq.a },
  })),
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '妖精漫画大全',
  description:
    '妖精漫画大全免费在线看，收录狐妖、猫妖、花妖等全类型妖精漫画，提供合集与全集资源入口。',
  url: 'https://spritezone.github.io/',
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />

      <Header />
      <main>
        <Hero />
        <Categories />
        <Featured />
        <Collections />
        <Articles />
        <Faq />
        <About />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}